import Nullstack from 'nullstack';
export default function IconZodiacGemini({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-gemini",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3a21 21 0 0 0 18 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 21a21 21 0 0 1 18 0"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "4.5",
    x2: "7",
    y2: "19.5"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "4.5",
    x2: "17",
    y2: "19.5"
  }), " ");
}